import { SHA256 } from "crypto-js";
import {
  BusinessUserPropertiesDto,
  BusinessInteractEventDto,
  BusinessFrequentPassengersEventParamsDTO,
} from "./interact_frequent_passengers.dto";
import dayjs from "dayjs";
import { RegistryDto } from "../../../services/registry.dto";
import {
  FlightType,
  IS_SEATS_REQUEST,
  IS_SELECTED_SEATS,
  IS_SELECTED_SERVICES,
  PassengerType,
} from "../../../../constants";
import { isSelectedSeatsCookie } from "../../../../dto/is-selected-seats.dto";

export const BusinessInteractFrequentPassengers = (
  data: Record<string, any>,
  registry: RegistryDto
): BusinessInteractEventDto => {
  const iSSeatsRequest = JSON.parse(
    window.localStorage.getItem(IS_SEATS_REQUEST) ?? ""
  ) as any;

  const { queryParams } = JSON.parse(
    window.localStorage.getItem("Origin") ?? "false"
  );
  const selectedSeats = JSON.parse(
    window.localStorage.getItem(IS_SELECTED_SEATS) ?? ""
  ) as isSelectedSeatsCookie[];

  const selectedServices: { ancillaryType: string; passengers: any[] }[] =
    JSON.parse(window.localStorage.getItem(IS_SELECTED_SERVICES) ?? "") as {
      ancillaryType: string;
      passengers: any[];
    }[];

  const {
    categoria,
    accion,
    etiqueta,
    micrositio,
    page_path,
    page_type,
    page_title,
    homemarket,
    login,
    negocio,
    buy_instance,
    user_props = {},
  } = data;

  const fullTrip = [];
  const fullTripDates = [];
  const fullTripTimes = [];

  registry.itineraryParts.map((flight) => {
    flight.segments.map((segment) => {
      fullTripDates.push(dayjs(segment.departure).format("YYYY-MM-DD"));
      fullTrip.push(`${segment.origin}-${segment.destination}`);
      fullTripTimes.push(
        `${dayjs(segment.departure).format("HH:mm")}(${segment.origin})|${dayjs(
          segment.arrival
        ).format("HH:mm")}(${segment.destination})`
      );
    });
  });

  const bagsServices = selectedServices.filter(
    (service) => service.ancillaryType === "luggage"
  );
  const carryOnServices = selectedServices.filter(
    (service) => service.ancillaryType === "carry"
  );
  const bundleInfoGoingReturn = registry.itineraryParts.map((flight) => {
    return flight.segments[0].fareBasis;
  });

  const totalLuggageQuantity = bagsServices.reduce((total, service) => {
    return (
      total +
      service.passengers.reduce((passengerTotal, passenger) => {
        return passengerTotal + passenger.quantity;
      }, 0)
    );
  }, 0);

  const totalCarryQuantity = carryOnServices.reduce((total, service) => {
    return (
      total +
      service.passengers.reduce((passengerTotal, passenger) => {
        return passengerTotal + passenger.quantity;
      }, 0)
    );
  }, 0);

  const passengersAdult = Number(queryParams?.ADT) || 0;
  const passengersChild = Number(queryParams?.CHD) || 0;
  const passengersInfant = Number(queryParams?.INF) || 0;
  const passengersPet = Number(queryParams?.PET) || 0;
  const pax = passengersAdult + passengersChild + passengersInfant;

  const event_params = new BusinessFrequentPassengersEventParamsDTO();
  event_params.evento_interactivo_categoria = categoria;
  event_params.evento_interactivo_accion = accion;
  event_params.evento_interactivo_etiqueta = etiqueta;
  event_params.micrositio = micrositio;
  event_params.page_path = page_path;
  event_params.page_type = page_type;
  event_params.page_title = page_title;
  event_params.homemarket = homemarket;
  event_params.environment = data?.enviroment || data?.environment || "production";
  event_params.login = login;
  event_params.negocio = negocio;
  event_params.buy_instance = buy_instance;
  event_params.currency = iSSeatsRequest?.context?.currency ?? "CLP";
  event_params.initial_date = queryParams.departureDate;
  event_params.end_date =
    queryParams.flightType === FlightType.RT ? queryParams.arrivalDate : "";
  event_params.from_iata = queryParams.origin;
  event_params.to_iata = queryParams.destination;
  event_params.trip_type =
    queryParams.flightType === FlightType.RT ? "roundtrip" : "oneway";
  event_params.time = fullTripTimes.join(",");
  event_params.fare_basis =
    queryParams.flightType === FlightType.RT
      ? `${bundleInfoGoingReturn[0]}|${bundleInfoGoingReturn[1]}`
      : `${bundleInfoGoingReturn[0]}`;
  event_params.bundle =
    queryParams.flightType === FlightType.RT
      ? `${bundleInfoGoingReturn[0].substring(
          1
        )}|${bundleInfoGoingReturn[1].substring(1)}`
      : `${bundleInfoGoingReturn[0].substring(1)}`;
  event_params.count_seats = Number(
    selectedSeats.filter(
      (item) =>
        item.passenger.baseAmount > 0 &&
        item.passenger.type !== PassengerType.INF
    ).length
  );
  event_params.count_bags = Number(totalLuggageQuantity);
  event_params.count_carry_on = Number(totalCarryQuantity);

  event_params.passengers_adult = passengersAdult;
  event_params.passengers_child = passengersChild;
  event_params.passengers_infant = passengersInfant;
  event_params.passengers_pet = passengersPet;
  event_params.pax = pax;

  event_params.full_trip = fullTrip.join();
  event_params.full_trip_dates = fullTripDates.join();
  // event_params.exchange_rate = exchange_rate; // falta esto

  const dto = new BusinessInteractEventDto();
  dto.event = "interacciones";
  dto.event_params = event_params;

  if (user_props && Object.keys(user_props).length) {
    const user_properties = new BusinessUserPropertiesDto();
    user_properties.pas_dni_hashed = SHA256(user_props.pas_dni).toString();
    if (user_props.birthday && dayjs(user_props.birthday).isValid()) {
      user_properties.birthday = dayjs(user_props.birthday).format(
        "DD/MM/YYYY"
      );
    }
    user_properties.user_type = user_props.user_type;
    dto.user_properties = user_properties;
  }

  return dto;
};
